import React, { Component } from "react";
import { signedRoundOff, getImgSrc, allSignedRoundOff } from "../../helpers/GlobalFunctions";

export default class TSAArmPosition extends Component {
	/**
	 * @description Function to get necessary data from the caseIntraOp data
	 * @returns Custom object with necessary data to show
	 * @memberof TSAArmPosition
	 */
	getIntraOpData = () => {
		const { caseIntraOp, operativeApproach } = this.props;
		if (!caseIntraOp) {
			return null;
		}
		const initialPlan = caseIntraOp?.plan?.Initial || null;
		const finalPlan = caseIntraOp?.plan?.FinalPlan || null;
		
		return {
			achieved: {
				acromionHumeralDistance: finalPlan?.Implant?.common?.Placement?.Metrics?.ComponentAngles?.acromionHumeralDistance || '',
				armLength: finalPlan?.Implant?.common?.Placement?.Metrics?.ComponentAngles?.armLength || '',
				lateralization: finalPlan?.Implant?.common?.Placement?.Metrics?.ComponentAngles?.lateralization || '',
			},
			planned: {
				acromionHumeralDistance: initialPlan?.Implant[`common_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.acromionHumeralDistance || '',
				armLength: initialPlan?.Implant[`common_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.armLength || '',
				lateralization: initialPlan?.Implant[`common_${operativeApproach}`]?.Placement?.Metrics?.ComponentAngles?.lateralization || '',
			}
		}
	}

	render() {
		const { operativeApproach, operativeSide } = this.props;
		const intraOpData = this.getIntraOpData();
		const armPositionImage = operativeApproach === 'anatomic' ? 'shoulder_anatomic_alignment.png' : 'shoulder_reverse_alignment.png';
		return (
			<div className="card">
				<div className="card-body alignment-block">
					<h4 className="mb-3 card-title">ARM POSITION</h4>
					<div className="row align-items-center">
						<div className="col-md-8">
							<table className="table table-bordered glenoid-table arm-position-table">
								<thead>
									<tr>
										<th> </th>
										<th>Planned</th>
										<th>Achieved</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Acromiohumeral Distance</td>
										<td>{intraOpData?.planned?.acromionHumeralDistance ? `${signedRoundOff(intraOpData?.planned?.acromionHumeralDistance, 1)}mm` : 'N/A'}</td>
										<td>{intraOpData?.achieved?.acromionHumeralDistance ? `${signedRoundOff(intraOpData?.achieved?.acromionHumeralDistance, 1)}mm` : 'N/A'}</td>
									</tr>
									<tr>
										<td>Arm Length</td>
										<td>{intraOpData?.planned?.armLength ? `${allSignedRoundOff(intraOpData?.planned?.armLength, 1)}mm` : 'N/A'}</td>
										<td>{intraOpData?.achieved?.armLength ? `${allSignedRoundOff(intraOpData?.achieved?.armLength, 1)}mm` : 'N/A'}</td>
									</tr>
									<tr>
										<td>Lateralization</td>
										<td>{intraOpData?.planned?.lateralization ? `${allSignedRoundOff(intraOpData?.planned?.lateralization, 1)}mm` : 'N/A'}</td>
										<td>{intraOpData?.achieved?.lateralization ? `${allSignedRoundOff(intraOpData?.achieved?.lateralization, 1)}mm` : 'N/A'}</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="col-md-4 text-center">
							<img className={`w-100 arm-position-img ${operativeSide === 'right' ? 'flip-image' : ''}`} src={getImgSrc(armPositionImage)} alt="Arm Position" />
						</div>
					</div>
				</div>
			</div>
		);
	}
}
